import { Nullable } from "@simplyk/common";

import { AmplitudeEvents } from "@/common/constants/amplitude";
import { useAmplitude } from "@/common/hooks/amplitude/useAmplitude";

export const ORGANIZATION_PAGE_LINK_HOVER_SELECTOR = "a:hover &";

export const useOrganizationPageLinkProps = (publishedOrgPageUrl: Nullable<string> | undefined) => {
  const { logAmplitudeEvent } = useAmplitude();

  if (!publishedOrgPageUrl) {
    return {};
  }

  return {
    component: "a" as const,
    href: publishedOrgPageUrl,
    target: "_blank",
    rel: "noopener",
    onClick: () => logAmplitudeEvent(AmplitudeEvents.OrgPageOpened, { from: "Org name & logo" }),
  };
};
